/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ActivityStatus {
  New = 0,
  Disqualified = 1,
  'Generating Proposal' = 2,
  'Proposal Ready' = 3,
  Lost = 4,
  'Ready to Order' = 5,
  'Order Submitted' = 6,
  'Order Initiated' = 11,
  'Order Received' = 7,
  'Order Shipped' = 8,
  'Order Canceled' = 9,
  'Order Delivered' = 10,
}
